<template>
    <LandingPageLayout
        v-bind="landingPageSharedData.getLandingPageLayoutProps()"
    >
        <Hero :authRegisterUrl="heroRegisterUrl" />

        <Demo />

        <Tools />

        <FeatureGrid />

        <FeaturePageLinks />

        <StepByStep />

        <CTA
            title="Ready to stop piecing your booking flow together?"
            subtitle="Create one professional page for your services and start taking bookings today."
            primaryButtonLabel="Start free"
            :primaryButtonUrl="ctaRegisterUrl"
            secondaryButtonLabel="See pricing"
            secondaryButtonUrl="#pricing"
        />

        <Pricing
            :plans="plans"
            :authRegisterUrl="pricingRegisterUrl"
        />

        <FAQ />

        <CTAWide
            title="Build a professional presence and start getting booked"
            subtitle="Join TinyCal to share one clean link, reduce scheduling friction, and run your client sessions with more confidence."
            primaryButtonLabel="Start building your page"
            :primaryButtonUrl="wideCtaRegisterUrl"
        />
    </LandingPageLayout>
</template>

<script setup lang="ts">
    import { UtmContentEnum } from '@/Shared/Service/Tracking/Utm/UtmEnums'
    import LandingPageLayout from '@/Marketing/LandingPage/Shared/LandingPageLayout.vue'
    import LandingPageSharedData from '@/Marketing/LandingPage/Entity/LandingPageSharedData'
    import Hero from '@/Marketing/LandingPage/Component/LandingPage/Hero.vue'
    import Demo from '@/Marketing/LandingPage/Component/LandingPage/Demo.vue'
    import Tools from '@/Marketing/LandingPage/Component/LandingPage/Tools.vue'
    import FeatureGrid from '@/Marketing/LandingPage/Component/LandingPage/FeatureGrid.vue'
    import FeaturePageLinks from '@/Marketing/LandingPage/Component/LandingPage/FeaturePageLinks.vue'
    import StepByStep from '@/Marketing/LandingPage/Component/LandingPage/StepByStep.vue'
    import CTA from '@/Marketing/LandingPage/Component/LandingPage/CTA.vue'
    import CTAWide from '@/Marketing/LandingPage/Component/LandingPage/CTAWide.vue'
    import Pricing from '@/Marketing/LandingPage/Component/LandingPage/Pricing.vue'
    import FAQ from '@/Marketing/LandingPage/Component/LandingPage/FAQ.vue'
    import Plan from '@/App/Plan/Entity/Plan'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface LandingPageProps {
        landingPageSharedDataRawData: any
        plansRawData: any
    }

    const props = defineProps<LandingPageProps>()
    const landingPageSharedData = LandingPageSharedData.hydrate(
        props.landingPageSharedDataRawData,
    )
    const urlFactory = new UrlFactory()
    const heroRegisterUrl = urlFactory.makeLandingPageRegisterUrl(
        UtmContentEnum.LandingPageHero,
    )
    const ctaRegisterUrl = urlFactory.makeLandingPageRegisterUrl(
        UtmContentEnum.LandingPageCta,
    )
    const pricingRegisterUrl = urlFactory.makeLandingPageRegisterUrl(
        UtmContentEnum.LandingPagePricing,
    )
    const wideCtaRegisterUrl = urlFactory.makeLandingPageRegisterUrl(
        UtmContentEnum.LandingPageWideCta,
    )
    const plans = Plan.hydrateMultiple(props.plansRawData)
</script>
